import { addFileToHTML, setErrorInHint, updateFileStatus } from "./dom-control";
import {
    fileDeleteUrl,
    fileUploadUrl,
    formatFormData,
    isError,
} from "./helpers";
import { postRequest } from "./request-handler";

type DeletedFile = {
    id: string;
};

type UploadedFile = {
    id: string;
    fileName: string;
    sizeInBytes: string;
};

type UploadedFiles = {
    uploadedFiles: UploadedFile[];
};

export default class FileManager {
    constructor(private appGuid: string, private tags: string) { }

    async uploadFiles<T extends HTMLElement>(box: T, filesToUpload: FileList) {
	const prefix = (box.hasAttribute('endpoint-prefix') ? box.getAttribute('endpoint-prefix') : '') as string;
        setErrorInHint(box, "");

        for (let i = 0; i < filesToUpload["length"]; i++) {
            const fileToUpload = filesToUpload[i];

            const fileDiv = addFileToHTML(box, fileToUpload);

            try {
                const formData = formatFormData(fileToUpload, this.tags);
                const data = await postRequest<UploadedFiles>(
                    fileUploadUrl(prefix, this.appGuid),
                    formData
                );
                const { id } = data.uploadedFiles[0];
                updateFileStatus(fileDiv, "success", id);
                
                let event = new Event("uploaded", {bubbles: true});
                box.dispatchEvent(event);
            } catch (error) {
                const { name } = fileToUpload;
                updateFileStatus(fileDiv, "upload-error");

                setTimeout(() => {
                    fileDiv.remove();
                }, 4000);

                if (isError(error)) {
                    setErrorInHint(box, error.message);
                }

                let event = new Event("upload-error", {bubbles: true});
                box.dispatchEvent(event);
            }
        }
    }

    async deleteFile<T extends HTMLElement>(element: T) {
	const prefix = (element.hasAttribute('endpoint-prefix') ? element.getAttribute('endpoint-prefix') : '') as string;

        setErrorInHint(element, "");

        const fileId = element.dataset.id;

        if (!fileId) return;

        updateFileStatus(element, "loading");

        const deleteUrl = fileDeleteUrl(prefix, this.appGuid, fileId);

        try {
            await postRequest<DeletedFile>(deleteUrl);
            element.remove();
        } catch (error) {
            updateFileStatus(element, "delete-error");

            if (isError(error)) {
                setErrorInHint(element, error.message);
            }
        }
    }
}